import React from 'react';
import { connect } from 'react-redux';
import { BrowserView, MobileView } from 'react-device-detect';
import './ArticleView.scss';
import Published from '../Articles/Content/containers/Published';
import CategoriesList from '../Articles/Content/containers/CategoriesList';
import SharingOptions from '../Articles/Content/containers/SharingOptions';
import ArticleContainer from '../Articles/Content/containers/ArticleContainer';
import BreadcrumbsA from '../Articles/Content/containers/Breadcrumbs/BreadcrumbsA';
import MainTitle from '../Articles/Content/containers/MainTitle';
import Subtitle from '../Articles/Content/containers/Subtitle';
import { getSuggestedArticles, articleById, shareSelectedArticle } from '../../store/actions/ArticlesActions';
import { withRouter } from 'react-router-dom';

class ArticleView extends React.Component {
  state = {
    suggestedArticles: [],
    postId: '',
    category: '',
    postTitle: 'Titulo articulo',
    article: {},
  };

  componentDidMount() {
    const id = this.props.match.params.postId;
    const category = this.props.match.params.category;
    this.fetchData(id, category);
    this.props.articleById(id)

    const params = {
      page: 1,
      limit: 4,
      category: category,
    };
    this.props.getSuggestedArticles(params, id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.postId !== this.props.match.params.postId) {
      this.setState({ postId: this.props.match.params.postId });
      this.setState({ category: this.props.match.params.category });
      window.scrollTo(0,0)
      this.props.articleById(this.props.match.params.postId)
      //console.log('articulo seleccionado', this.props.match.params.postId)
    }
  }

  fetchData = (id, category) => {
    this.setState({ postId: id });
    this.setState({ category: category });
  };

  handleShare = async () => {
    await this.props.shareSelectedArticle(this.props.article);
    /* const id = this.props.article.id;
    const params = {
      page: 1,
      limit: 4,
      category: this.props.article.categories[0],
    };
    await this.props.getSuggestedArticles(params, id); */
  };


  render() {
    const { featuredArticle, suggestedArticles } = this.props;
    const link = `https://contactaabogado.com/articulos/${this.state.category}/${this.state.postId}`;

    let showArticle = () => {
      return (
        <ArticleContainer
          key={this.state.article.id}
          isFeatured={this.state.postId === featuredArticle.id}
          article = {this.props.article}
        />
      );
    };

    let showSuggestions = suggestedArticles && suggestedArticles.data && suggestedArticles.data.length > 0 && suggestedArticles.data.map((article) => {
        return (
          <Published
            key={article.id}
            article = {article}
          />
        );
      });


    return (
      <>
        <BrowserView viewClassName="browser-custom-class">
          <div className="article-view-content">
            <div className="article-view-content-wrapper">
              <BreadcrumbsA
                postTitle={ this.props.article && this.props.article.title ? this.props.article.title : ""  }
                postCategory={this.state.category}
              />
              <div className="article-view-content-section">
                <div className="article-view-content-section-left">
                  <div className="article-section">{showArticle()}</div>

                  {showSuggestions && 
                    <div className="suggestions-list">
                      <div className="suggestions-title">
                        <MainTitle text="Sugerencias para ti" />
                      </div>
                      {showSuggestions}
                    </div>
                  }
                </div>

                <div className="article-view-content-section-right">
                  <div className="sharing-options">
                    <SharingOptions link={link} handleShare={this.handleShare}/>
                  </div>

                  <div className="categories-list">
                    <CategoriesList />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BrowserView>

        <MobileView viewClassName="mobile-custom-class">
          <div className="article-view-content">
            <div className="article-view-content-wrapper">
              <div className="article-view-content-section">
                <BreadcrumbsA
                  postTitle={ this.props.article && this.props.article.title ? this.props.article.title : ""  }
                  postCategory={this.state.category}
                />
                <div className="article-section">{showArticle()}</div>

                <div className="sharing-options">
                  <SharingOptions link={link} handleShare={this.handleShare} />
                </div>

                {showSuggestions &&
                  <div className="suggestions-list">
                    <div className="suggestions-title">
                      <Subtitle
                        text="Sugerencias para ti"
                        margin="featured"
                      ></Subtitle>
                    </div>
                    {showSuggestions}
                  </div>
                }

                <div className="categories-list">
                  <CategoriesList />
                </div>
              </div>
            </div>
          </div>
        </MobileView>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  featuredArticle: state.articlesReducer.articles.featured,
  suggestedArticles: state.articlesReducer.articles.suggested,
  article: state.articlesReducer.selectedArticle,
});

const mapDispatchToProps = (dispatch) => ({
  getSuggestedArticles: (params, id) => dispatch(getSuggestedArticles(params, id)),
  shareSelectedArticle: (article) =>
    dispatch(shareSelectedArticle(article)),
  articleById: (id) => dispatch(articleById(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ArticleView));
